import { render, staticRenderFns } from "./afiliacion-sistema-riesgos-ver.vue?vue&type=template&id=411f0dd6&scoped=true&"
import script from "./afiliacion-sistema-riesgos-ver.vue?vue&type=script&lang=js&"
export * from "./afiliacion-sistema-riesgos-ver.vue?vue&type=script&lang=js&"
import style0 from "./afiliacion-sistema-riesgos-ver.vue?vue&type=style&index=0&id=411f0dd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f0dd6",
  null
  
)

export default component.exports